import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['gross', 'net', 'discount'];

  connect() {
    this.hasGrossTarget && this.grossTarget.addEventListener('change', this.onGrossChanged.bind(this));
    this.hasNetTarget && this.netTarget.addEventListener('change', this.onNetChanged.bind(this));
    this.hasDiscountTarget && this.discountTarget.addEventListener('change', this.onDiscountChanged.bind(this));
  }

  onGrossChanged() {
    let { grossValue, discountValue } = this.values;
    this.netTarget.value = this.toString(grossValue - discountValue);
  }

  onNetChanged() {
    let { discountValue, netValue } = this.values;
    this.grossTarget.value = this.toString(discountValue + netValue) ;
  }

  onDiscountChanged() {
    let { grossValue, discountValue } = this.values;
    this.netTarget.value = this.toString(grossValue - discountValue);
  }

  get values() {
    return {
      grossValue: this.toNumber(this.grossTarget.value),
      netValue: this.toNumber(this.netTarget.value),
      discountValue: this.toNumber(this.discountTarget.value)
    }
  }

  toString(value) {
    return `${(Math.max.apply(Math, [value, 0]) / 100).toFixed(2)}`.replaceAll(',', '').replaceAll('.', ',');
  }

  toNumber(value) {
    return +value.replaceAll(/[\D]/ig, '');
  }
};